import { render, staticRenderFns } from "./OrderOpUnitInfoCard.vue?vue&type=template&id=60fcf14c&"
import script from "./OrderOpUnitInfoCard.vue?vue&type=script&lang=js&"
export * from "./OrderOpUnitInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports